<template>
    <form @submit="onSubmit" action="/booking/retrieve" method="post">
        <input type="hidden" name="_token" :value="csrf">
        <div class="mt-3">
            <TextInput
                label="Email"
                name="email"
                v-model="email"
                :validation="v$.email"
                styling="w-full"
            ></TextInput>
        </div>
        <div class="mt-6">
            <TextInput
                label="Booking Reference"
                name="reference"
                v-model="reference"
                :validation="v$.reference"
                styling="w-full"
            ></TextInput>
        </div>

        <button
            type="submit"
            class="bg-ap-primary text-white rounded-lg px-8 py-2 mt-4 w-full"
        >
            Search
        </button>
    </form>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { required, email, helpers } from '@vuelidate/validators';
import TextInput from '../TextInput.vue';

const { withMessage } = helpers;

export default {
    setup() {
        return {
            v$: useVuelidate(),
        };
    },
    data() {
        return {
            email: null,
            reference: null,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        };
    },
    validations() {
        return {
            email: {
                required: withMessage('Email address is required', required),
                email: withMessage('Email is not valid', email),
            },
            reference: {
                required: withMessage('Booking reference is required', required),
            },
        };
    },
    methods: {
        async onSubmit(e) {
            const result = await this.v$.$validate();

            if (!result) {
                e.preventDefault();
                return false;
            }

            return true;
        },
    },
    components: {
        TextInput,
    },
};
</script>
